import React from "react";
import "./Categories.scss";
import { useStateValue } from "../context/StateProvider";

const categories = [
  "plants",
  "pots"
];

function Categories() {
  const [{category}, dispatch] = useStateValue();
  
  const setActive = (e, category) => {
    let prevActive = document.querySelector(".categories__category.active");
    if (prevActive) prevActive.classList.remove("active");
    e.preventDefault();
    e.target.classList.add("active");
    dispatch({
      type: "SET_CATEGORY",
      category: category,
    });
  };

  return (
    <div className="categories">
      <span
        className={`categories__category ${(!category || category==="all")&&'active'} `}
        onClick={(e) => setActive(e, "all")}
      >
        All Products
      </span>
      {categories.map((categor,i) => (
        <span
          className={`categories__category ${(category===categor)&&'active'} `}
          key={i}
          onClick={(e) => setActive(e, categor)}
        >
          {categor}
        </span>
      ))}
    </div>
  );
}
export default Categories;
